<aside class="sidebar">
  <div class="sidebar__content">
    <ul class="nav">
      <li class="nav__item">
        <a [routerLink]="['/gdb']" class="nav__link nav-home">
          <ion-icon name="home-outline" class="icon"></ion-icon>
          <span>Home</span>
        </a>
      </li><!--end of nav__item-->

      <li class="nav__item">
        <a href="#" class="nav__link nav__dropdown">
          <div class="nav__link__content">
            <ion-icon name="code-working" class="icon"></ion-icon>
            <span>Coding</span>
          </div>

          <div class="nav__link__arrow">
            <ion-icon name="chevron-down" class="icon"></ion-icon>
          </div>
        </a>

        <ul class="subnav">
          <li class="subnav__item">
            <a [routerLink]="'/gdb/coding/refactor'" class="subnav__link refact">
              <ion-icon name="sync-circle-sharp" class="icon"></ion-icon>
              <span>Refactorización</span>
            </a>
          </li>

          <li class="subnav__item">
            <a [routerLink]="'/gdb/coding/unit-test'" class="subnav__link test">
              <ion-icon name="document-text" class="icon"></ion-icon>
              <span>Test unitarios</span>
            </a>
          </li>

          <li class="subnav__item">
            <a [routerLink]="'/gdb/coding/automation'" class="subnav__link auto">
              <ion-icon name="code-slash" class="icon"></ion-icon>
              <span>Automatización</span>
            </a>
          </li>
        </ul><!--end of subnav-->
      </li><!--end of nav__item-->

      <li class="nav__item">
        <a href="#" class="nav__link nav__dropdown">
          <div class="nav__link__content">
            <ion-icon name="code-outline" class="icon"></ion-icon>
            <span>Non Coding</span>
          </div>

          <div class="nav__link__arrow">
            <ion-icon name="chevron-down" class="icon"></ion-icon>
          </div>
        </a>

        <ul class="subnav">
          <li class="subnav__item">
            <a [routerLink]="'/gdb/no-coding/knowledge'" class="subnav__link g">
              <ion-icon name="settings-sharp" class="icon"></ion-icon>
              <span>G. Conocimiento</span>
            </a>
          </li>

          <li class="subnav__item">
            <a [routerLink]="'/gdb/no-coding/manual-test'" class="subnav__link pruebas">
              <ion-icon name="file-tray-full" class="icon"></ion-icon>
              <span>Pruebas manuales</span>
            </a>
          </li>

          <li class="subnav__item">
            <a [routerLink]="'/gdb/no-coding/user-stories'" class="subnav__link hu">
              <ion-icon name="people-circle" class="icon"></ion-icon>
              <span>Historias de usuario</span>
            </a>
          </li>

          <li class="subnav__item">
            <a [routerLink]="'/gdb/no-coding/chew'" class="subnav__link chew">
              <ion-icon name="clipboard-outline" class="icon"></ion-icon>
              <span>Chew</span>
            </a>
          </li>
        </ul><!--end of subnav-->
      </li><!--end of nav__item-->
    </ul><!--end of nav-->
  </div><!--end of sidebar__content-->

  <div class="sidebar__drop">
    <a [routerLink]="" class="sidebar__link">
      <ion-icon name="chevron-forward" class="icon"></ion-icon>
    </a>
  </div><!--end of drop-->
</aside>


